import styled from "styled-components";

export const Magic8BallPositionContextDefaultBox = styled.div`
    position: relative;
    margin: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)
`;
